import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Department } from '../../models/department';
import { DepartmentService } from '../../services/department.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { Meetingtype } from '../../models/meetingtype';
import { MeetingtypeService } from '../../services/meetingtype.service';
import { CommitteeService } from '../../services/committee.service';
import { DatePipe } from '@angular/common';
import { BasicMaster } from '../../models/basicmaster';
import { BasicMasterService } from '../../services/basicmaster.service';

@Component({
  selector: 'app-meetingtype',
  templateUrl: './meetingtype.component.html',
  styleUrls: ['./meetingtype.component.css']
})
export class MeetingtypeComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerMeetingtype: PageHeader;
  entity: Meetingtype = new Meetingtype();
  selectedMeetingtype: Meetingtype = new Meetingtype();
  editingEntity: Meetingtype = new Meetingtype();
  Meetingtype: any;
  MeetingtypeColumns: any[]= [];
  typeaccess: Array<BasicMaster> = [];
  selectedMeetingTypeAccess: any;


  listView: boolean = true;
  formCaption: string = '';
  locations: Array<Location> = [];
  selectedLocation: any;
  _selectedMeetingtype: any;
  employees: Array<Employee> = [];
  selectedEmployee: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  departments: Array<Department> = [];
  pipe = new DatePipe('en-US');
  opened: boolean = false;
  details: any;
  constructor(
    private _departmentService: DepartmentService,
    private _MeetingtypeService: MeetingtypeService,
    private _committeeService: CommitteeService,
    private _locationService: LocationService,
    private _employeeService: EmployeeService,
    private _basicMasterService: BasicMasterService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerMeetingtype = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));

    this.Meetingtype = [];
    this.getAllMeetingtype();

  }
  ngAfterViewInit(): void {
    this.MeetingtypeColumns = [
      { field: "SlNo", title: 'Sl No.', filter: false, sortable: true, width: 70 },
      { field: "Code", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: "MeetingTypeName", title: 'Meeting Group', filter: true, sortable: true, width: 150 },      
      { field: 'DisplayText', title: 'Meeting Group Access', filter: true, sortable: true, width: 150 },
      { field: "MeetingtypeDescription", title: 'Description ', filter: true, sortable: true, width: 150 }, 
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 }, 
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._MeetingtypeService.getAllMeetingtype('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((Meetingtype: Array<Meetingtype>) => {
      this.Meetingtype = {
        data: Meetingtype,
        total: Meetingtype[0] ? Meetingtype[0].TotalCount : 0
      }
    });
  }

  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._MeetingtypeService.getAllMeetingtype(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((Meetingtype: Array<Meetingtype>) => {
        this.Meetingtype = {
          data: Meetingtype,
          total: Meetingtype[0] ? Meetingtype[0].TotalCount : 0
        }
      });
    }
  }

  getallMeetingTypeAccess(filter: string) {
    this._basicMasterService.getBasicMastersByName('Meetingtypeaccess', filter, this.defaultRowsCount, 1).subscribe((data: Array<BasicMaster>) => {
      this.typeaccess = data;
    })
  }
  getAllMeetingtype() {
    this._MeetingtypeService.getAllMeetingtype('', Number(this.defaultPageSize), 1, 0, 0).subscribe((Meetingtype: Array<Meetingtype>) => {
    this.Meetingtype = {
        data: Meetingtype,
        total: Meetingtype[0] ? Meetingtype[0].TotalCount : 0
      }
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._MeetingtypeService.deleteMeetingtype(this.selectedMeetingtype.MeetingType_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearMeetingtype();
            this.getAllMeetingtype();
          },
          )
        }
      }
    });
          this.getallMeetingTypeAccess(''); 
  }

  initPageHeader(): PageHeader {
    let headerMeetingtype = new PageHeader();
    headerMeetingtype.PageCaption = "Meeting Group";
    headerMeetingtype.IconClass = "bi bi-shield-shaded";
    return headerMeetingtype;
  }

  deleteMeetingtype(event: any) {
    if (event.seletedRows[0]) {
      this.selectedMeetingtype.MeetingType_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Meeting Group",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addMeetingtype(event: any) {
    this.listView = false;
    this.clearMeetingtype();
    this.getallMeetingTypeAccess('');

    this.formCaption = "Add Meeting Group";
  }

  editMeetingtype(event: any): void {
    if (event.seletedRows[0]) {
      this._MeetingtypeService.viewMeetingtype(event.seletedRows[0]).subscribe((Meetingtypes: Array<Meetingtype>) => {
        let editEnity = Meetingtypes[0] ? Meetingtypes[0] :  new Meetingtype(); 
        if (editEnity) { 
          this.editingEntity = editEnity;
          this.selectedMeetingTypeAccess = { DisplayValue: editEnity.MeetingTypeAccess, DisplayText: editEnity.DisplayText };
          this.entity = { ...this.editingEntity }; 
          this.listView = false;
          this.formCaption = "Edit Meeting Group";
          this.getallMeetingTypeAccess(''); 
          this.entity.EntityMetaData = [
            { FieldName: 'MeetingTypeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting Group Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            { FieldName: 'MeetingTypeAccess', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting Group Access is required' },
          ];
        }
      });
    }
  }

  save(event: any): void {
    if(parseInt(this.entity.Code)==0)
    {
      this.notification.showWarning('zero not allowed');
      return
    }
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._MeetingtypeService.checkDuplication(this.entity.MeetingType_Id, this.entity.Code).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Meeting Group already exists');
          this.saveDisabled = false;
        }
        else {
          // alert(JSON.stringify(this.entity));
          this._MeetingtypeService.saveMeetingtype(this.entity).subscribe(() => {
            if (this.entity.MeetingType_Id == "00000000-0000-0000-0000-000000000000") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearMeetingtype();
            this.getAllMeetingtype();
          })
        }
      });
    }

    else {
      this.saveDisabled = false;
    }
  }

  goToBackTab(): void {

    this.listView = true;

  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllMeetingtype();
  }

  refreshMeetingType(event: any): void {
    this.Meetingtype=[];
    this.getAllMeetingtype();
  }

  clearMeetingtype(): void {
    this._selectedMeetingtype = {};

    this.entity = new Meetingtype();
    this.selectedMeetingTypeAccess = {};
    this.saveDisabled = false;

  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.MeetingType_Id = dataItem.MeetingType_Id;
    this.details = [];
    this._MeetingtypeService.viewMeetingtype(this.entity.MeetingType_Id).subscribe((Meetingtype: Array<Meetingtype>) => {
      this.opened = true;
      this.details = Meetingtype[0];
    })}
}

